module.exports = __webpack_public_path__ + "static/media/Wheeler_Portrait.fd367534.png";